// import card1IMG from '@/assets/imgs/services/1.png';
// import card2IMG from '@/assets/imgs/services/2.png';
// import card3IMG from '@/assets/imgs/services/3.png';
// import card4IMG from '@/assets/imgs/services/4.png';
import { Layout } from '@/components/generic';

import GetMoreCustomers from './GetMoreCustomers';
import Header from './Header';
import Service from './Service';

export const Services = () => {
  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title='Services'>
        <div className='card px-12 py-22 max-lg:p-8 max-lg:px-6'>
          <div className='max-w-215 mx-auto'>
            <Header />
          </div>
        </div>
        <div className='grid grid-cols-2 gap-4 mb-3'>
          <Service
            title='Self-Custody Wallet'
            description='We create your wallet directly on-chain. You hold the keys, you own the funds. ⚡ Not your keys, not your coins.'
            cta=' Learn more'
          />
          <Service
            title='Request My Card'
            description='Spend your crypto effortlessly in thousands of online and offline stores. Your card, your crypto, your rules — fast, borderless, and seamless.'
            cta='Learn more'
          />
          <Service
            title='Social Login'
            description='Instant wallet creation using just your email — no downloads, no friction. Powered by Magic Link & account abstraction. Anyone can start in seconds.'
            cta='Learn more'
          />
          <Service
            title='Multi-Chain Funding'
            description=' Your main wallet is BSC — but now you can deposit from almost any chain. Thanks to Debridge, the possibilities are nearly endless.'
            cta='Learn more'
          />
        </div>
        <GetMoreCustomers />
      </Layout>
    </div>
  );
};
